app.preserveInitialRequestInit = function(config) {
	if(config && config.requestUrlWithParameters) {
		sessionStorage.setItem('initialRequestWithParams', config.requestUrlWithParameters);
	}
};
